module.exports = __webpack_public_path__ + "static/media/main_light_ico.18cec051.svg";